export const KEY_COOKIE = 'lt_go_to_app_mobile_banner';
export const TOP_MOBILE_BANNER_TEST_ID = 'TOP_MOBILE_BANNER_TEST_ID';
export const LOOCK_BUTTON_TEST_ID = 'LOOCK_BUTTON_TEST_ID';
export const HEIGHT = 76;
